
import { mapMutations, mapState } from 'vuex';
import RecipeSummary from '@/components/recipeSummary.vue';
import RecipesCategories from '@/components/recipesCategories.vue';
import LoadMore from '@/components/ui/loadMore.vue';
import Intermission from '@/components/intermission';

export default {
  name: 'RecipeCategory',

  components: {
    RecipeSummary,
    RecipesCategories,
    LoadMore,
    Intermission,
  },

  async fetch() {
    try {
      await this.getRecipes();
    } catch (_) {
      return this.$nuxt.error({ statusCode: 404 });
    }
  },

  data() {
    return {
      page: 1,
      lastPage: null,
      perPage: 6,
      loading: false,
    };
  },

  computed: {
    ...mapState(['patientId', 'recipes', 'recipeCategories']),

    ...mapState({
      info: (state) => state.options.field_recipes_start,
    }),

    title() {
      return this.category ? this.category.name : this.info.title;
    },

    description() {
      return this.category ? this.category.description : this.info.description;
    },

    slug() {
      return this.$route.params.slug;
    },

    recipesIntermission() {
      const array = [...this.filteredRecipes];
      for (let i = this.perPage; i < array.length + 1; i += 1 + this.perPage) {
        array.splice(i, 0, { id: `inter${i}` });
      }
      return array;
    },

    filteredRecipes() {
      return this.category
        ? this.recipes.filter((r) =>
            r['recipe-category'].includes(this.category.cat_ID)
          )
        : this.recipes;
    },

    category() {
      return this.slug
        ? this.recipeCategories.find((c) => c.slug === this.slug)
        : null;
    },
  },

  mounted() {
    this.$bolev.metaEvent({
      type: 'pageView',
      patientId: this.patientId,
    });
  },

  methods: {
    ...mapMutations(['setRecipes']),

    async getRecipes() {
      this.loading = true;
      const { data, headers } = await this.$wp.recipes({
        perPage: this.perPage,
        page: this.page,
        category: this.category ? this.category.cat_ID : null,
      });
      this.loading = false;
      if (data && data.length) {
        this.setRecipes(data);
        this.page++;
        if (headers['x-wp-totalpages']) {
          this.lastPage = parseInt(headers['x-wp-totalpages']);
        }
      }
    },
  },

  head() {
    if (this.category) {
      return {
        title: this.category.cat_name,
        meta: [
          {
            name: 'description',
            hid: 'description',
            content: this.category.description,
          },
          {
            name: 'og_description',
            hid: 'og_description',
            content: this.category.description,
          },
        ],
      };
    } else {
      return this.$seo.page('recipes', this.$route.path);
    }
  },
};
